import { render, staticRenderFns } from "./ComAppHeader.vue?vue&type=template&id=3cda7aa4&"
import script from "./ComAppHeader.vue?vue&type=script&lang=js&"
export * from "./ComAppHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports